import {Component, OnInit, ViewChild} from '@angular/core';
import { OnDestroy } from '@angular/core';
import { DevExtremeMessageLoaderService } from "./devextreme-message-loader.service";
import { UserDefinedPrinterComponent } from './modules/admin/printer-setup/user-defined-printer/user-defined-printer.component';
import { DocumentOperatorPanelComponent } from './modules/document/document-operator-panel/document-operator-panel.component';
import { PublicReportComponent } from './modules/production-status/public-report/public-report.component';
import { NavComponent } from './shared/components/nav/nav.component';
import { LanguageService } from './shared/services/language.service';
import { UserService } from './shared/services/user.service';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: []
})
//ref: https://stackoverflow.com/questions/71374941/angular-msal-v2-login-via-redirect-redirecting-3-or-more-times-before-token-a

export class AppComponent implements OnInit, OnDestroy {
  navVisible = true;


  @ViewChild(NavComponent, {static:false}) navComponent: NavComponent;

  constructor(private userService: UserService,
              private languageService: LanguageService,
              private devExtremeMessageLoaderService: DevExtremeMessageLoaderService,
  ) {
  }

  ngOnDestroy(): void {
  }


  onActivate(component) {
    if (component instanceof PublicReportComponent
      || component instanceof UserDefinedPrinterComponent
        || component instanceof DocumentOperatorPanelComponent ) {
      this.navVisible = false;
      return;
    }
    else if (this.userService.isLoggedIn) {
      this.navVisible = true;
    }

    if (component.router && component.router.url === '/login') {
      this.navComponent.initNav(false);
    } else {
      this.userService.load(); // Request reload of data to avoid blank data for first-time users...
      this.navComponent.initNav(true);
    }

    this.devExtremeMessageLoaderService.loadMessages(this.userService.languageId);
  }

  ngOnInit() {

  }
}

